import axios from "axios";
import React from "react";
import Card from "./Card";
import '../carousel.css';

const options = {
    method: 'GET',
    url: 'https://ieee-spectrum-api.p.rapidapi.com/api',
    headers: {
        'X-RapidAPI-Key': '058d9375c7msh2f9a403d214d3eap1a7bbejsn4fe1fdb67b1d',
        'X-RapidAPI-Host': 'ieee-spectrum-api.p.rapidapi.com'
    }
};

export default function Carousel() {

    const [data, setData] = React.useState([])      //State for incoming API data

    React.useEffect(() => {
        axios.request(options).then((response) => {     //useEffect hook for setting our API data
            setData(response.data)
        })
    }, [])

    const cardElements1 = data.slice(0, 3).map(card => {
        return <Card
            newsTitle={card.newsTitle}
            newsUrl={card.newsUrl}
            newsTimetoRead={card.newsTimetoRead}
            newsSubHeadline={card.newsSubHeadline}
            newsDatePublished={card.newsDatePublished}
            newsSections={card.newsSections}
            newsImgSrc={card.newsImgSrc}
            newsImgAlt={card.newsImgAlt}
            newsLikes={card.newsLikes}
            newsIsSponsored={card.newsIsSponsored}
        />
    })

    const cardElements2 = data.slice(3, 6).map(card => {
        return <Card
            newsTitle={card.newsTitle}
            newsUrl={card.newsUrl}
            newsTimetoRead={card.newsTimetoRead}
            newsSubHeadline={card.newsSubHeadline}
            newsDatePublished={card.newsDatePublished}
            newsSections={card.newsSections}
            newsImgSrc={card.newsImgSrc}
            newsImgAlt={card.newsImgAlt}
            newsLikes={card.newsLikes}
            newsIsSponsored={card.newsIsSponsored}
        />
    })
    return (
        data.length > 0 ?
            <div className="container">
                <input type="radio" name="dot" id="one" />
                <input type="radio" name="dot" id="two" />
                <div className="main-card">
                    <div className="cards">
                        {cardElements1}
                    </div>
                    <div className="cards">
                        {cardElements2}
                    </div>
                </div>
                <div className="button">
                    <label for="one" className=" active one"></label>
                    <label for="two" className="two"></label>
                </div>
            </div>
            : <div class="wave">
                <div class="ball"></div>
                <div class="ball"></div>
                <div class="ball"></div>
                <div class="ball"></div>
                <div class="ball"></div>
            </div>
    )
}